






























































































import { Component, Watch, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import CreateWalletTransferRequest from '@/models/Accounts/DepositAccounts/Wallets/CreateWalletTransferRequest';
import Wallet from '@/models/Accounts/DepositAccounts/Wallets/Wallet';
import DepositAccountSummary from "@/models/Accounts/DepositAccounts/DepositAccountSummary";
import FieldLabel from '@/components/Shared/FieldLabel.vue';

@Component({ name: 'WalletsTransferDialog', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    dialog = false;
    valid = false;
    createUxWalletTransferRequest: CreateWalletTransferRequest = new CreateWalletTransferRequest();

    @Prop({required: true})
    wallet: Wallet;

    @Prop({required: true})
    account: DepositAccountSummary;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.createUxWalletTransferRequest = new CreateWalletTransferRequest();
        }
    }

    get secondaryWalletOptions() {
        return this.account.wallets.filter(walletInList => walletInList.id !== this.wallet.id);
    }

    get currentWalletCurrency() {
        return this.wallet.availableBalance.currency;
    }

    async transfer() {
        if (!this.valid) {
            return;
        }
        else {
            this.dialog = false;
            await DepositAccountModule.createNewWalletTransfer(this.createUxWalletTransferRequest);
        }
    }

}
